import { useState, useEffect, useMemo, useRef } from "react"
import { Card, Container, Row, Col, Button } from "react-bootstrap"
import DangerBtn from "../../../components/DangerBtn"
import request from "../../../functions/request"
import ModifyDraw from "./ModifyDraw"

function NonStartDraw({setCurrKey}){
    const [drawList, setDrawList] = useState([])
    const [modifingDrawID, setModifingDrawID] = useState(-1)

    const requestSended = useRef(false)
    const requestRecv = useRef(false)

    useEffect(()=>{
        if (!requestSended.current){
            requestSended.current = true
            fetch(window.location.protocol+"//"+window.location.hostname+"/api/admin/luckydraw/drawList").then(r=>r.json()).then(resp=>{
                if (resp.status){
                    requestRecv.current = true
                    setDrawList(resp.luckydraws.filter((x)=>{
                        return x.is_start === 0
                    }))
                }
            })
        }
    }, [])

    return useMemo(()=>{
        if (modifingDrawID !== -1){
            return <ModifyDraw modifingDrawID={modifingDrawID} setModifingDrawID={setModifingDrawID}/>
        }

        return (
            <Container fluid>
                {
                    drawList.length===0?<h3 style={{textAlign: "center"}}>{requestRecv.current?"没有未开始的抽奖活动":"正在查询。。。"}</h3>:
                    <Row>
                        {
                            drawList.map((x)=>{
                                return (
                                    <Col key={x.id} md={6} xl={4}>
                                        <Card className="mb-2" style={{textAlign: "left"}}>
                                            <Card.Body>
                                                <Card.Title>活动名:&nbsp;{x.name}</Card.Title>
                                                <br/>
                                                <div style={{display: "flex"}}>
                                                    <div style={{flex: 1, display: "flex", gap: 8}}>
                                                        <Button onClick={()=>{
                                                            request.post(window.location.protocol + "//" + window.location.hostname + "/api/admin/luckydraw/startDraw", {id: x.id}).then(resp=>{
                                                                if (resp.status)
                                                                    setCurrKey("StartedDraw")
                                                                else
                                                                    window.alert(resp.reason)
                                                            })
                                                        }}>开始</Button>
                                                        <Button onClick={()=>{ setModifingDrawID(x.id) }}>编辑</Button>
                                                    </div>
                                                    <div style={{textAlign: "right"}}>
                                                        <DangerBtn name="删除" dangerMessage="删除之后所有相关记录都会删除噢，确定吗？" onClick={()=>{
                                                            request.post(window.location.protocol+"//"+window.location.hostname+"/api/admin/luckydraw/delDraw", {id: x.id}).then(resp=>{
                                                                if (resp.status){
                                                                    setDrawList((old)=>{
                                                                        return old.filter((y)=>{return y !== x})
                                                                    })
                                                                }
                                                                else{
                                                                    window.alert(resp.reason)
                                                                    window.location.reload()
                                                                }
                                                            })
                                                        }}/>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                )
                            })
                        }
                    </Row>
                }
            </Container>
        )
    }, [setCurrKey, drawList, modifingDrawID])
}

export default NonStartDraw